import{d as o}from"./chunk-QTRVW56Z.js";import{b as e}from"./chunk-7IJU7BS3.js";import{m as r}from"./chunk-HBP5N4FR.js";r();function d(){let t=o();return e(t)}export{d as a};
//# sourceMappingURL=chunk-V3QRDPTY.js.map
